import { render, staticRenderFns } from "./OrcamentoCabecalho.vue?vue&type=template&id=5131eae4&scoped=true"
import script from "./OrcamentoCabecalho.vue?vue&type=script&lang=js"
export * from "./OrcamentoCabecalho.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoCabecalho.vue?vue&type=style&index=0&id=5131eae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5131eae4",
  null
  
)

export default component.exports